var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "66px",
    viewBox: "0 0 60 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cup-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cup-|-2.1.Quarter-Finals-|-Played-(Desktop)",
    transform: "translate(-734.000000, -550.000000)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(179.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.097986,166 L612.995969,166 C614.095053,165.99999 614.988197,166.886873 614.995929,167.98593 C615.229799,201.229113 605.38698,222.567137 585.467471,232 C563.995891,222.341736 553.873187,200.983688 555.09936,167.925856 C555.139244,166.85088 556.02227,166 557.097986,166 Z",
    id: "Path-3-Copy-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.9383c52dd5814bc3b13a608c8570e3a6.svg";
export { ForwardRef as ReactComponent };